import { generateRequest } from '@/api/generateRequest'

let config = {
    getToken: {
        url: '/client/wx/getToken',
        apiType: 'check',
    },
    getTokenByCode: {
        url: '/client/wx/getTokenByCode',
        apiType: 'check',
    }
}


const apiHomePage = {
	getToken: (data, variable) => generateRequest(data, config.getToken, variable),
    getTokenByCode: (data, variable) => generateRequest(data, config.getTokenByCode, variable),
}

export default apiHomePage
